import { gql } from "@apollo/client";

import { AskAiChatMessageFragment } from "./get-ask-ai-session-query";

export default gql`
  ${AskAiChatMessageFragment}
  mutation linkArtifactToChatMessageMutation(
    $chatSessionId: Int!
    $messageId: String!
    $artifactId: Int!
  ) {
    linkCreatedArtifactToChatMessage(
      chatSessionId: $chatSessionId
      messageId: $messageId
      artifactId: $artifactId
    ) {
      chatSession {
        id
        updated
        messages {
          edges {
            node {
              id
              ...AskAiChatMessageFragment
            }
          }
        }
      }
    }
  }
`;
